import * as React from 'react'
import type {SVGProps} from 'react'
const SvgMedical = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 48 48" {...props}>
        <path
            fill="#142745"
            d="M29.57 27.25v-2.79a.46.46 0 0 0-.46-.46h-3.25v-3.25a.46.46 0 0 0-.46-.46h-2.79a.46.46 0 0 0-.46.46V24h-3.26a.46.46 0 0 0-.46.46v2.79a.46.46 0 0 0 .46.46h3.25V31a.46.46 0 0 0 .46.46h2.79a.46.46 0 0 0 .46-.46v-3.29h3.25a.46.46 0 0 0 .47-.46m-9.28-10.68h7.43v-1.86h-7.43zm-5.57 0v18.57h-.46A3.26 3.26 0 0 1 11 31.89V19.82a3.26 3.26 0 0 1 3.25-3.25zm17.18 0v18.57H16.11V16.57h2.32v-2.32a1.39 1.39 0 0 1 1.39-1.39h8.36a1.39 1.39 0 0 1 1.39 1.39v2.32zm5.1 3.25v12.07a3.26 3.26 0 0 1-3.25 3.25h-.46V16.57h.46A3.26 3.26 0 0 1 37 19.82"
        />
    </svg>
)
export default SvgMedical
